// Table of contents:
// 1 Table
// 2 Delete assignee
// 3 Create assignee
// 4 Edit assignee
import { RoleAssignments } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createMembers = (): RoleAssignments => {
  return {
    // 1 Table
    table: {
      enabled: true,
      title: getTranslationsForConfig('members.table.title'), // t('members.table.title')
      columns: [
        {
          // assignee
          dataType: 'string',
          field: 'assignee',
          filter: true,
          filterPlaceholder: getTranslationsForConfig(
            'members.table.columns.assignee.filterPlaceholder',
          ), // t('members.table.columns.assignee.filterPlaceholder')
          header: getTranslationsForConfig(
            'members.table.columns.assignee.header',
          ), // t('members.table.columns.assignee.header')
          sortable: true,
        },
        {
          // role
          dataType: 'role',
          field: 'role',
          filter: true,
          header: getTranslationsForConfig('members.table.columns.role.header'), // t('members.table.columns.role.header')
          sortable: true,
        },
      ],
      emptyMessageDetails: getTranslationsForConfig(
        'members.table.emptyMessageDetails',
      ), // t('members.table.emptyMessageDetails')
      emptyMessageTitle: getTranslationsForConfig(
        'members.table.emptyMessageTitle',
      ), // t('members.table.emptyMessageTitle')
      paginator: true,
      rows: 20,
      rowsPerPageOptions: [20, 50, 100],
      sortField: 'projectName',
      sortOrder: 1,
      scrollHeight: '70vh',
    },
    // 2 Delete assignee
    deleteAssignee: {
      enabled: true,
    },
    // 3 Create assignee
    createAssignee: {
      enabled: true,
      // Assignee
      assignee: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.assignee.label',
        ), // t('roleAssignments.table.edit.dialog.form.assignee.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.assignee.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.assignee.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Role
      role: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.role.label',
        ), // t('roleAssignments.table.edit.dialog.form.role.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.role.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.role.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Project
      project: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.project.label',
        ), // t('roleAssignments.table.edit.dialog.form.project.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.project.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.project.placeholder')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
    },
    // 4 Edit assignee
    editAssignee: {
      enabled: true,
      // Assignee
      assignee: {
        enabled: true,
        label: getTranslationsForConfig(
          'members.table.edit.dialog.form.assignee.label',
        ), // t('members.table.edit.dialog.form.assignee.label')
        placeholder: getTranslationsForConfig(
          'members.table.edit.dialog.form.assignee.placeholder',
        ), // t('members.table.edit.dialog.form.assignee.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Role
      role: {
        enabled: true,
        label: getTranslationsForConfig(
          'members.table.edit.dialog.form.role.label',
        ), // t('members.table.edit.dialog.form.role.label')
        placeholder: getTranslationsForConfig(
          'members.table.edit.dialog.form.role.placeholder',
        ), // t('members.table.edit.dialog.form.role.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Project
      project: {
        enabled: true,
        label: getTranslationsForConfig(
          'members.table.edit.dialog.form.project.label',
        ), // t('members.table.edit.dialog.form.project.label')
        placeholder: getTranslationsForConfig(
          'members.table.edit.dialog.form.project.placeholder',
        ), // t('members.table.edit.dialog.form.project.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
  }
}
